import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Survey, ContactSupportQueryParams } from "../types";

interface SurveyState {
  surveys: Array<Survey>;
  surveysTotal: number;
  survey?: Survey;
}

const initialState: SurveyState = {
	surveys: [],
	surveysTotal: 0,
};

export const surveySlice = createSlice({
	name: "survey",
	initialState,
	reducers: {
		setSurveys: (state, action) => {
			state.surveys = action.payload.data;
			state.surveysTotal = action.payload.total;
		},
		setSurvey: (state, action) => {
			state.survey = action.payload.data;
		},
		changeStatusSurvey: (state, action) => {
			const { id, status } = action.payload;
			const index = state.surveys.findIndex(el => el._id === id);
			state.surveys[index].status = status;
		},
	},
});

export const selectSurveys = (state: RootState) => state.survey.surveys;
export const selectSurveysTotal = (state: RootState) => state.survey.surveysTotal;
export const selectSurvey = (state: RootState) => state.survey.survey;

export const { setSurveys, setSurvey, changeStatusSurvey } = surveySlice.actions;

export interface GetSurveysAsyncPayload {
  query: ContactSupportQueryParams;
	callback?: () => void;
}
export interface GetSurveyPayload {
  id: string;
	callback: () => void;
}

export interface UpdateSurveyPayload {
  id?: number;
  status?: string;
	note?: string;
	caringStaffId?: number;
	callback?: () => void;
}

export const getSurveysAsync = createAction(
	"surveys/getSurveys",
	(payload: GetSurveysAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getSurveyDetailAsync = createAction(
	"surveys/getSurveyDetail",
	(payload: GetSurveyPayload) => ({
		payload: payload,
	})
);

export const updateSurveyAsync = createAction(
	"surveys/updateSurvey",
	(payload: UpdateSurveyPayload) => ({
		payload: payload,
	})
);

export default surveySlice.reducer;
